import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
var AssessmentQuestionOptionService = /** @class */ (function (_super) {
    tslib_1.__extends(AssessmentQuestionOptionService, _super);
    function AssessmentQuestionOptionService(http) {
        var _this = _super.call(this, 'assessment-question-option', http) || this;
        _this.http = http;
        return _this;
    }
    AssessmentQuestionOptionService.prototype.ngOnInit = function () {
    };
    return AssessmentQuestionOptionService;
}(BaseService));
export { AssessmentQuestionOptionService };
